<template>
    <div></div>
</template>

<script>
import { storeService } from '@core/services';
import qz from 'qz-tray';

export default {
    data() {
        return {
            storeId: null,
            certificateId: null,
            customerInvoicePrinterModel: null
        };
    },
    computed: {
        type_Status() {
            return (status) => {
                if (status == 0) {
                    return 'داخل سالن'
                }
                if (status == 1) {
                    return 'بیرون بر'
                }
            }
        },
    },
    props: {
        customerInvoice: {
            type: Object,
            default: () => { },
        },
        chefInvoice: {
            type: Object,
            default: () => { },
        },
        provider: {
            type: Object,
            default: () => { },
        },
    },
    methods: {
        printChefInvoice() {
            let customerDescription = "";
            if (this.chefInvoice.customerDescription) {
                customerDescription = `
                <div class="text-center" style="margin-top: 1.1rem;">
                    <div style="margin-bottom: 0.25rem;font-size: 12px;">توضیحات سفارش</div>
                    <div class="mb-0" style="font-size: 15px;">${this.chefInvoice.customerDescription}</div>
                </div>
             `
            }

            let customerLastName = "";
            if (this.chefInvoice.customerLastName) {
                customerLastName = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 0.5rem;margin-left: 0.5rem;margin-right: 0.5rem;">
                    <div style="margin-bottom: 0.25rem;font-size: 12px;">نام مشتری</div>
                    <div class="mb-0" style="font-size: 13px;">${this.chefInvoice.customerLastName}</div>
                </div>
            `
            }

            let noItem = "";
            if (!this.chefInvoice.items.length) {
                noItem = `
               <div style="margin-bottom: 15px;margin-top: 15px;" class="text-center">موردی وجود ندارد</div>
            `
            }

            let isUpdate = "";
            if (this.chefInvoice.isUpdate) {
                isUpdate = `
                <div style="margin-bottom: 15px;font-size: 18px;" class="text-center">*** فیش اصلاحی ***</div>
            `
            }

            let tableId = "";
            if (this.chefInvoice.tableId) {
                tableId = `
                <div class="d-flex align-items-center justify-content-between" style="margin-left: 0.5rem;margin-right: 0.5rem;">
                    <div style="margin-bottom: 0.25rem;font-size: 12px;">شناسه میز</div>
                    <div class="mb-0">${this.chefInvoice.tableId}</div>
                </div>
            `
            }

            let itemsHTML = "";
            this.chefInvoice.items.forEach((item, index) => {
                itemsHTML += `
            <div class="d-flex align-items-center" style="padding-left: 0.6rem; padding-right: 0.6rem;padding-top: 0.4rem; padding-bottom: 0.4rem;border-bottom: 2px solid #000;">
                <div class="d-flex align-items-center" style="margin-left: 0.2rem;">
                  <div>${index + 1}</div>
                  <span>-</span>
                </div>
                <div style="width: 100%;">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="font-size: 15px;">
                            ${item.name}
                        </div>
                        <div class="d-flex align-items-center">
                            <span style="margin-left: 0.3rem;">${item.count}</span>
                            <span style="font-size: 10px;">عدد</span>
                        </div>
                    </div>
                </div>
            </div>
            `;
            });

            let htmlContent = `
                <html>
                    <head>
                        <meta charset="utf-8">
                        <style>
                            body {
                                font-family: 'Verdana', 'Tahoma';
                                direction: rtl; 
                                text-align: right;
                            }
                            .d-flex { display: flex; }
                            .justify-content-center { justify-content: center; }
                            .justify-content-between { justify-content: space-between; }
                            .align-items-center { align-items: center; }
                            .text-center { text-align: center; }
                        </style>
                    </head>
                    <body>
                        <div class="d-flex justify-content-center">
                            <div style="width: 93vw;">
                                ${isUpdate}
                                <div class="d-flex justify-content-center" style="margin-left: 0.25rem; margin-right: 0.25rem;">
                                        <div class="d-flex align-items-center" style="font-size: 18px;">
                                            <span>
                                                ${this.chefInvoice.createdAt ? new Date(this.chefInvoice.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0, 2).join(":") : '-'}
                                            </span>   
                                            <span style="margin-left: 0.25rem; margin-right: 0.25rem;">-</span>  
                                            <span>   
                                                ${this.chefInvoice.createdAt ? new Date(this.chefInvoice.createdAt).toLocaleDateString('fa-IR') : '-'}
                                            </span>   
                                        </div>
                                </div>
                                ${noItem}
                                <div style="margin-left: 0.25rem; margin-right: 0.25rem;margin-top: 1.2rem;margin-bottom: 1rem;border-right: 2px solid #000; border-left: 2px solid #000; border-top: 2px solid #000;">
                                        ${itemsHTML}
                                </div>
                                ${tableId}
                                <div class="d-flex align-items-center justify-content-between" style="margin-top: 0.5rem;margin-left: 0.5rem;margin-right: 0.5rem;">
                                        <div style="margin-bottom: 0.25rem;font-size: 12px;">نوع سفارش</div>
                                        <div class="mb-0" style="font-size: 15px;">${this.type_Status(this.chefInvoice.type)}</div>
                                </div>
                                    ${customerLastName}
                                    <hr style="margin-top: 1.1rem;border-top: 2px solid #4e4e4e" style="margin-left: 0.5rem;margin-right: 0.5rem;">
                                    ${customerDescription}
                                <div class="text-center" style="margin-top: 1.1rem;">
                                        <div style="margin-bottom: 0.25rem;font-size: 12px;">شماره سفارش</div>
                                        <div class="mb-0" style="font-size: 26px;border-bottom: solid 0.5px;padding-bottom: 1rem;">${this.chefInvoice.dailyNumber}</div>
                                </div>
                            </div>
                        </div>
                    </body>
                </html>
            `;

            const config = qz.configs.create(this.chefInvoice.printers.model);
            qz.print(config, [{
                type: 'pixel',
                format: 'html',
                flavor: 'plain',
                data: htmlContent
            }]);
        },
        printCustomerInvoice() {
            let tableItems = ""
            this.customerInvoice.items.forEach((item, index) => {
                tableItems += `
                    <tr>
                        <th style="font-size: 12px;">${item.name_Fa}</th>
                        <th style="font-size: 12px;">
                                ${item.finalPrice ? item.finalPrice.toLocaleString('fa-IR') : item.finalPrice}
                        </th>
                        <th style="font-size: 12px;">${item.number.toLocaleString('fa-IR')}</th>
                        <th style="font-size: 12px;">
                                ${item.finalPrice ? (item.finalPrice * item.number).toLocaleString('fa-IR') : item.finalPrice * item.number}
                        </th>
                    </tr>
            `;
            });

            let orderType = "";
            if (this.customerInvoice.type == 1) {
                orderType = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">نوع سفارش :</div>
                    <div style="font-size: 13px;">
                      ${this.type_Status(this.customerInvoice.type)}
                    </div>
                </div>
            `
            }

            let orderAmount = "";
            if (this.customerInvoice.taxAmount != 0 || this.customerInvoice.discountAmount || this.customerInvoice.usedWalletAmount) {
                orderAmount = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">جمع سفارش :</div>
                    <div style="font-size: 13px;">
                        ${this.customerInvoice.orderAmount ?
                        this.customerInvoice.orderAmount.toLocaleString('fa-IR') + ' ' + 'ریال' :
                        this.customerInvoice.orderAmount}
                    </div>
                </div>
            `
            }

            let taxAmount = "";
            if (this.customerInvoice.taxAmount != 0) {
                taxAmount = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">مالیات :</div>
                    <div style="font-size: 13px;">
                        ${this.customerInvoice.taxAmount ?
                        this.customerInvoice.taxAmount.toLocaleString('fa-IR') + ' ' + 'ریال' : this.customerInvoice.taxAmount
                    }
                    </div>
                </div>
            `
            }


            let productDiscountAmount = "";
            if (this.customerInvoice.productDiscountAmount) {
                productDiscountAmount = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">تخفیف محصولات :</div>
                    <div style="font-size: 13px;">
                        ${this.customerInvoice.productDiscountAmount ?
                        this.customerInvoice.productDiscountAmount.toLocaleString('fa-IR') + ' ' + 'ریال' :
                        this.customerInvoice.productDiscountAmount}
                    </div>
                </div>
            `
            }

            let discountAmount = "";
            if (this.customerInvoice.discountAmount) {
                discountAmount = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">تخفیف :</div>
                    <div style="font-size: 13px;">
                        ${this.customerInvoice.discountAmount ?
                        this.customerInvoice.discountAmount.toLocaleString('fa-IR') + ' ' + 'ریال' :
                        this.customerInvoice.discountAmount}
                    </div>
                </div>
            `
            }

            let campaignDiscountAmount = "";
            if (this.customerInvoice.campaignDiscountAmount) {
                campaignDiscountAmount = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">تخفیف کمپین :</div>
                    <div style="font-size: 13px;">
                        ${this.customerInvoice.campaignDiscountAmount ?
                        this.customerInvoice.campaignDiscountAmount.toLocaleString('fa-IR') + ' ' + 'ریال' :
                        this.customerInvoice.campaignDiscountAmount}
                    </div>
                </div>
            `
            }

            let courierFee = "";
            if (this.customerInvoice.courierFee) {
                courierFee = `
               <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">هزینه ارسال :</div>
                    <div style="font-size: 13px;">
                        ${this.customerInvoice.courierFee ?
                        this.customerInvoice.courierFee.toLocaleString('fa-IR') + ' ' + 'ریال' :
                        this.customerInvoice.courierFee}
                    </div>
                </div>
            `
            }

            let usedWalletAmount = "";
            if (this.customerInvoice.usedWalletAmount) {
                usedWalletAmount = `
                <div class="d-flex align-items-center justify-content-between" style="margin-top: 10px">
                    <div style="font-size: 12px;">اعتبار استفاده شده :</div>
                    <div style="font-size: 13px;">
                        ${this.customerInvoice.usedWalletAmount ?
                        this.customerInvoice.usedWalletAmount.toLocaleString('fa-IR') + ' ' + 'ریال' :
                        this.customerInvoice.usedWalletAmount}
                    </div>
                </div>
            `
            }

            let address = "";
            if (this.customerInvoice.address) {
                address = `
                <div style="margin-bottom: 18px;padding-left: 9px;padding-right: 6px;font-size: 14px;text-align: justify;">
                 ${'آدرس : ' + this.customerInvoice.address}
                </div>
            `
            }

            let customerName = "";
            if (this.customerInvoice.firstName && this.customerInvoice.lastName) {
                customerName = `
                <div style="margin-top: 18px;padding-left: 9px;padding-right: 6px;font-size: 14px;text-align: justify;">
                 ${'مشتری گرامی : ' + this.customerInvoice.firstName + this.customerInvoice.lastName}
                </div>
            `
            }

            let customerPhoneNumber = "";
            if (this.customerInvoice.phoneNumber) {
                customerPhoneNumber = `
                <div style="margin-top: 5px;margin-bottom: 5px;padding-left: 9px;padding-right: 6px;font-size: 14px;text-align: justify;">
                 ${'شماره همراه : ' + this.customerInvoice.phoneNumber}
                </div>
            `
            }

            let htmlContent = `
                <html>
                    <head>
                        <meta charset="utf-8">
                        <style>
                            body {
                                font-family: 'Verdana', 'Tahoma';
                                direction: rtl; 
                                text-align: right;
                            }
                            .d-flex { display: flex; }
                            .justify-content-center { justify-content: center; }
                            .justify-content-between { justify-content: space-between; }
                            .align-items-center { align-items: center; }
                            .text-center { text-align: center; }
                            .custom-table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 13px;
                            }
                            .custom-table th {
                                padding-bottom: 6px;
                                padding-top: 6px;
                                padding-left: 3px;
                                padding-right: 3px;
                                font-weight: 500;
                                text-align: center;
                                border: 2px solid #000000;
                            }
                            .custom-table td {
                                font-weight: 500;
                                padding-bottom: 6px;
                                padding-top: 6px;
                                padding-left: 3px;
                                padding-right: 3px;
                                text-align: center;
                                border: 2px solid #000000;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="d-flex justify-content-center">
                            <div style="width: 93vw;">
                                <div class="d-flex justify-content-center align-items-center" style="font-size: 18px;">
                                    <div style="border-bottom: 2px solid #000000;padding-bottom: 12px;margin-bottom: 17px">${this.provider.name}</div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center">
                                        <div style="font-size: 12px;padding-left: 3px;">شماره سفارش :</div>
                                        <div>${this.customerInvoice.dailyOrderNumber}</div>
                                    </div>
                                    <div class="d-flex align-items-center" style="font-size: 13px;">
                                        <span>
                                            ${this.customerInvoice.createdAt ? new Date(this.customerInvoice.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0, 2).join(":") : '-'}
                                        </span>   
                                        <span style="margin-left: 0.25rem; margin-right: 0.25rem;">-</span>  
                                        <span>   
                                            ${this.customerInvoice.createdAt ? new Date(this.customerInvoice.createdAt).toLocaleDateString('fa-IR') : '-'}
                                        </span>   
                                    </div>
                                </div>
                                ${customerName}
                                ${customerPhoneNumber}
                                ${address}
                                <div style="font-size: 16px;margin-top: 18px;" class="text-center">لیست سفارش</div>
                                <div style="padding-bottom: 9px;">
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th style="font-size: 15px;">نام</th>
                                                <th style="font-size: 15px;">فی</th>
                                                <th style="font-size: 15px;">تعداد</th>
                                                <th style="font-size: 15px;">قیمت</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${tableItems}
                                        </tbody>
                                    </table>
                                </div>
                                <div style="padding-left: 9px;padding-right: 6px;">
                                    ${orderType}
                                    ${productDiscountAmount}
                                    ${orderAmount}
                                    ${taxAmount}
                                    ${campaignDiscountAmount}
                                    ${discountAmount}
                                    ${courierFee}
                                    ${usedWalletAmount}
                                </div>    
                                <div class="text-center" style="margin-top: 16px">
                                    <div style="font-size: 12px;margin-bottom: 6px;">مبلغ قابل پرداخت</div>
                                    <div style="font-size: 18px;border-bottom: solid 0.5px;padding-bottom: 1rem;">
                                        ${this.customerInvoice.amountPayable ?
                    this.customerInvoice.amountPayable.toLocaleString('fa-IR') + ' ' + 'ریال' :
                    this.customerInvoice.amountPayable}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </body>
                </html>
            `;

            const config = qz.configs.create(this.customerInvoicePrinterModel);
            qz.print(config, [{
                type: 'pixel',
                format: 'html',
                flavor: 'plain',
                data: htmlContent
            }]);
            setTimeout(() => {
                this.$emit('deleteInvoice');
            }, 100);
        },
        connectQZ() {
            this.certificateId = localStorage.getItem("certificateId");
            storeService.printerCertificateKey(this.storeId, this.certificateId).then(({ data }) => {
                qz.security.setCertificatePromise((resolve, reject) => {
                    resolve(data);
                });
                qz.websocket.connect().then(() => {
                    qz.security.setSignatureAlgorithm("SHA512");
                    qz.security.setSignaturePromise((message) => {
                        return (resolve, reject) => {
                            storeService.printerSignatureMessage(this.storeId, this.certificateId, message).then(({ data }) => {
                                resolve(data);
                            });
                        };
                    });
                })
                    .catch(err => {
                        this.$notif({ type: 'error', title: 'مشکل در اتصال به پرینتر' });
                    });
            });
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.customerInvoicePrinterModel = localStorage.getItem("printerModel")
        if (!qz.websocket.isActive()) {
            this.connectQZ();
        }
    },
    beforeDestroy() {
        if (qz.websocket.isActive()) {
            qz.websocket.disconnect();
        }
    },
};
</script>